import React, { useState, useEffect } from "react";
import classes from "./reportAProblem.module.css";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import { Button } from "../../../../../stories/Button/Button";
import { Checkbox } from "../../../../../stories/Checkbox/Checkbox";
import { TextArea } from "../../../../../stories/TextArea/TextArea";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import modalClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import ReportAProblemDone from "./ReportAProblemDone";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";

const ReportAProblemModal = ({ show, setShow }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [isProblem, setIsProblem] = useState();
  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, []);
  const [detail, setDetail] = useState();

  const problems = [
    "The coach was late for training",
    "The coach did not show up for training.",
    "Boorish behavior.",
    "Other (nothing from the above)",
  ];
  return (
    <>
      <style>{`
      .modal-body{
        padding:0px 32px;
      }
              @media screen and (max-width: 580px) {
            .modal .modal-dialog {
              width: 90% !important;
              margin: 0px 10%;
            }
        }
            @media screen and (max-width: 768px) {
                .${modalClasses.body} {
                  padding:0px 24px;
                }
                .${modalClasses.header} {
                    margin:24px;
                  }
            }

      `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        headerStyles={{
          marginBottom: "0px",
          paddingBottom: "24px",
        }}
        borderRadius={"20px"}
        footerStyles={
          isMobile
            ? {
              padding: "16px 24px",
              margin: "0px",
            }
            : {
              padding: "16px 32px",
              margin: "0px",
            }
        }
        width={"509px"}
        header={
          <div>
            <h4
              style={
                isMobile
                  ? {
                    ...Fonts.h3,
                    fontSize: "24px",
                    lineHeight: "32px",
                    color: Colors.neutralShadesOfNero,
                  }
                  : {
                    ...Fonts.h4,
                    fontSize: "26px",
                    lineHeight: "36px",
                    color: Colors.neutralShadesOfNero,
                  }
              }
            >
              Report a problem
            </h4>
          </div>
        }
        footer={
          <div className={classes.footerBtns}>
            <LinkButtonWithIcon
              text={"Cancel"}
              primary={false}
              size={"Medium"}
              customStyle={{
                marginRight: "24px",
                color: Colors.neutralShadesOfNero
              }}
              onClick={() => setShow(false)}
            />
            <Button
              label={"Submit"}
              primary={true}
              size={"Medium"}
              customStyle={{
                width: "max-content",
                padding: '14px 36px'
              }}
              onClick={() => {
                setConfirm(true);
                setShow(false);
              }}
            />
          </div>
        }
      >
        <div className={classes.modalContent}>
          <div className={[isMobile ? classes.mb24 : classes.mb32].join(" ")}>
            <div className={[classes.pb8].join(" ")}>
              {problems.map((item, i) => {
                return (
                  <div className={[classes.mb16].join(" ")} key={i}>
                    <Checkbox
                      value={isProblem}
                      setValue={setIsProblem}
                      label={`${item}`}
                    />
                  </div>
                );
              })}
            </div>
            {isProblem == "Other (nothing from the above)" && (
              <TextArea
                state={detail}
                setter={setDetail}
                placeholder="Tell us more about why you can’t come..."
              />
            )}
          </div>
        </div>
      </ModalSkeleton>
      <ReportAProblemDone show={confirm} setShow={setConfirm} />
    </>
  );
};

export default ReportAProblemModal;
